const WH_DIV_ID = "whDivId";

export const setWhDivisionId = (whDivId: number) => {
  localStorage.setItem(WH_DIV_ID, whDivId.toString());
};

export const getWhDivisionId = (): number | undefined => {
  const stored = localStorage.getItem(WH_DIV_ID);
  return stored ? parseInt(stored, 10) : undefined;
};

export const removeWhDivisionId = () => {
  localStorage.removeItem(WH_DIV_ID);
};
